module.exports = require("@comparaonline/cicl-funnel-schema/dist/enums/checkout");